
const RouterAuth = ({children}: any) => {
  
  return children;
}

export default RouterAuth;